import type { Attachment } from "@/lib/types";

export function canRetouchAttachment(
  attachment:
    | Pick<Attachment, "id" | "kind" | "isGenericImage">
    | null
    | undefined,
): boolean {
  if (!attachment?.id) return false;
  if (attachment.isGenericImage) return false;
  if (attachment.kind === "video" || attachment.kind === "embed") return false;
  return true;
}
